<template>
  <div class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div>
    <el-card shadow="never" style="margin-top: 0px">
      <div style="margin-top: 10px">
        <el-form
          :inline="true"
          :model="queryParam"
          ref="queryForm"
          label-width="80px"
        >
          <el-form-item>
            <el-radio-group :disabled="value || queryParam.searchDay ? true : false" v-model="radio" @change="onChangeDay">
              <el-radio
                :disabled="queryParam.searchDay ? true : false"
                v-for="todo in redioDayRange"
                :key="todo.id"
                :label="todo.id"
                >{{ todo.dayDes }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="员工" prop="workerId">
            <el-select v-model="queryParam.workerId" placeholder="请选择员工">
              <el-option
                v-for="item in workersList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份:">
            <!-- <el-select
              :disabled="radio ? true : false"
              v-model="queryParam.number"
              placeholder="请选择月份"
            >
              <el-option
                v-for="item in mouthOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->
            <el-date-picker :disabled="radio || queryParam.searchDay ? true : false" @change="getChoosedMouth"
              v-model="value"
              type="month"
              placeholder="请选择月份"
              value-format="M"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="日期" prop="searchDay">
            <el-date-picker
              @change="handleChangeDate"
              :disabled="radio || value ? true : false"
              v-model="queryParam.searchDay"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="版本:" prop="templateId">
            <el-select v-model="queryParam.templateId" placeholder="请选择">
              <el-option
                v-for="item in cardTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务:" prop="serverId">
            <el-select v-model="queryParam.serverId" placeholder="请选择业务">
              <el-option
                v-for="item in storeBusinessList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              size="medium"
              class="operator-btn2"
              icon="el-icon-refresh"
              @click="handleResetSearch()"
              >重 置</el-button
            >
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-search"
              @click="onBtnSearch()"
              >查 询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="table-container" style="margin-top: 20px">
      <div class="d-flex jc-between ai-center manage-btn">
        <div class="tab-box">
          <div
            class="tab-box-item"
            :class="Inv == index ? 'tab-box-item-checked' : ''"
            v-for="(item, index) in tabsList"
            :key="index"
            @click="handleTab(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <!-- @row-click="rowClick" -->
      <el-table
        ref="tableData"
        style="width: 100%"
        :data="tableData"
        max-height="540"
        v-loading="listLoading"
        border
        :summary-method="getSummaries"
        show-summary
        highlight-current-row
        :header-cell-style="{
          'text-align': 'center',
          background: '#edf3fe',
          color: '#0d6fb8',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column v-if="Inv == 1" prop="workerName" label="员工姓名">
        </el-table-column>
        <el-table-column prop="serverName" label="业务"></el-table-column>
        <el-table-column
          prop="templateId"
          label="版本"
        >
          <template slot-scope="{ row }">
            {{ row.templateId == 1 ? "B" : row.templateId == 2 ? "A" : "" }}
          </template>
        </el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column
          prop="total"
          :label="Inv == 0 ? '总金额' : Inv == 1 ? '金额' : '总金额'"
        ></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="pageSizes"
        :total="totalPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import globaldata from "@/utils/globaldata";
import timeUtils from "@/utils/timeUtils";
import { formatDate } from "@/utils/date";
import { saleList, storeBusinessListGet } from "@/api/SalesDataAnalysis";
import { adminJobPlanPlanWorksGET } from "@/api/vtwonewcontent";
export default {
  data() {
    return {
      listLoading: false,
      value: undefined,
      queryParam: {
        //分页查询
        pageNum: 1, //当前第几页
        pageSize: 10,
        storeFrontId: undefined, //店铺id
        allData: true, //数据类型   true:所有业务  false:员工数据
        startDate: undefined, //开始时间
        endDate: undefined, //结束时间
        workerId: null, //员工ID
        templateId: undefined, //卡类型
        serverId: undefined, //业务id
        searchDay:undefined
      },
      totalPage: 1, //总共页数
      pageSizes: [10, 20, 50, 100],
      radio: null,
      redioDayRange: [
        { id: 0, dayDes: "近三天" },
        { id: 1, dayDes: "近一周" },
        { id: 2, dayDes: "本月" },
        { id: 3, dayDes: "本季度" },
        { id: 4, dayDes: "本年度" },
      ],
      mouthOptions: [],
      cardTypeList: [
        {
          label: "A类型",
          value: 2,
        },
        {
          label: "B类型",
          value: 1,
        },
      ],
      Inv: 0,
      tabsList: ["全部", "员工"],
      tableData: [],
      workersList: [],
      storeBusinessList: [], //门店列表
    };
  },
  mounted() {
    this.getMouthList();
    this.getList();
    this.adminJobPlanPlanWorksAxios();
    this.getStoreServeceList();
  },
  methods: {
    getStartAndEndDateByMonth(month) {
      const yearNow = new Date().getFullYear();
      const startDate = new Date(yearNow, month - 1, 1);
      const endDate = new Date(yearNow, month, 0);
      console.log(
        formatDate(startDate, "yyyy-MM-dd"),
        formatDate(endDate, "yyyy-MM-dd"),
        "事情结束"
      );
      return [startDate, endDate];
    },
    getChoosedMouth(e){
      console.log(e,'选择的月份')
      let mouthArr = this.getStartAndEndDateByMonth(e)
      this.$set(this.queryParam, "startDate", formatDate(mouthArr[0], "yyyy-MM-dd"));
      this.$set(this.queryParam, "endDate", formatDate(mouthArr[1], "yyyy-MM-dd"));
    },
    getList() {
      this.listLoading = true;
      this.$set(
        this.queryParam,
        "storeFrontId",
        globaldata.getAdminStore().storeFrontId
      );
      this.$set(this.queryParam, "allData", this.Inv == 0 ? true : false);
      saleList(this.queryParam).then((res) => {
        this.listLoading = false;
        console.log(res, "销售分析数据");
        this.tableData = res.data.list;
        this.totalPage = res.data.total;
      });
    },
    //获取员工列表
    async adminJobPlanPlanWorksAxios() {
      const response = await adminJobPlanPlanWorksGET({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.workersList = response.data;
      }
    },
    //获取门店列表
    async getStoreServeceList() {
      const response = await storeBusinessListGet({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      console.log(response, "response");
      if (response.code === 20000) {
        this.storeBusinessList = response.data;
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总价";
          return;
        }
        if (index == 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getCardType(e) {
      return e.templateId == 1 ? "B" : e.templateId == 2 ? "A" : "";
    },
    // 获取月份数据
    getMouthList() {
      for (let i = 1; i <= 12; i++) {
        this.mouthOptions.push({
          value: i,
          label: i + "月",
        });
      }
    },
    handleChangeDate(e) {
      console.log(e, "e");
      this.$set(this.queryParam, "startDate", e);
      this.$set(this.queryParam, "endDate", e);
    },
    getCurrentTime() {
      let now = new Date();
      let dayVal = this.radio == 0 ? 2 : this.radio == 1 ? 6 : null;
      let bfVal = timeUtils.getBeforeDayOfDate(now, dayVal);
      let rangeTime = [
        formatDate(bfVal, "yyyy-MM-dd"),
        formatDate(now, "yyyy-MM-dd"),
      ];
      return rangeTime;
    },
    onChangeDay(val) {
      let rangeTimeVal;
      // 获取近几天日期区间
      if (val == 0 || val == 1) {
        rangeTimeVal = this.getCurrentTime();
      } else if (val == 2) {
        // 获取当月日期区间
        let currentMouthDate = timeUtils.getCurrentMouth();
        rangeTimeVal = [
          formatDate(currentMouthDate[0], "yyyy-MM-dd"),
          formatDate(currentMouthDate[1], "yyyy-MM-dd"),
        ];
      } else if (val == 3) {
        // 获取本季度日期区间
        let currentQuarterDate = timeUtils.getCurrentQuarter();
        rangeTimeVal = [
          formatDate(currentQuarterDate[0], "yyyy-MM-dd"),
          formatDate(currentQuarterDate[1], "yyyy-MM-dd"),
        ];
      } else if (val == 4) {
        // 获取本年度日期区间
        let currentNearDate = timeUtils.getCurrentNear();
        rangeTimeVal = [
          formatDate(currentNearDate[0], "yyyy-MM-dd"),
          formatDate(currentNearDate[1], "yyyy-MM-dd"),
        ];
      }
      console.log(rangeTimeVal, "rangeTimeVal");
      this.$set(this.queryParam, "startDate", rangeTimeVal[0]);
      this.$set(this.queryParam, "endDate", rangeTimeVal[1]);
    },
    handleTab(index) {
      this.Inv = index;
      this.handleResetSearch();
    },
    // 重置按钮点击事件
    handleResetSearch() {
      this.radio = null;
      this.value = undefined
      this.$set(this.queryParam, "startDate", undefined);
      this.$set(this.queryParam, "endDate", undefined);
      this.$refs.queryForm.resetFields();
      this.onBtnSearch();
    },
    // 查询按钮点击事件
    onBtnSearch() {
      this.queryParam.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  text-align: left !important;
}
.table-container {
  border: 0px;
}
.manage-btn {
  background-color: #fff;
  padding: 20px !important;
  text-align: right;
  box-sizing: border-box;
}
.tab-box {
  padding: 5px;
  background: #ecf3fd;
  display: flex;
  &-item {
    // margin-top: 1px;
    padding: 10px 36px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 10px;
    color: #74798c;
    &-checked {
      color: #ffffff;
      border-radius: 8px;
      background: #0e6fb8;
    }
  }
}
/* 合计行整体样式修改开始 */
.el-table /deep/ .el-table__footer-wrapper tbody td {
  background: #ecf3fd;
  color: white;
  text-align: center;
  color: #1875bb;
}

/* 合计行整体样式修改结束*/
</style>



// WEBPACK FOOTER //
// src/views/marketing-manager/sales-data-analysis/index.vue